import { FormInput } from "./Form";

type ZCompactSearchBarProps = {
	searchText: string;
	onChange: (newSearchText: string) => void;
	className?: string;
	placeholderText?: string;
	id?: string;
};

export const ZCompactSearchBar = ({ searchText, onChange, className, placeholderText, id }: ZCompactSearchBarProps) => {
	return (
		<div className={`compact-search d-inline-flex align-items-center my-1 px-1 ${className}`}>
			<i className="mdi mdi-magnify search-icon me-1" />
			<FormInput id={id} containerClass="flex-grow" placeholder={placeholderText} value={searchText} name={"Search"} onChange={(e) => onChange(e.target.value)} />
		</div>
	);
};
